export type CupomItem = {
    localId: number
    id: number | null
    cupomId: number | null
    nomeCupom: string
    valor: number
    percentual: boolean
    quantidadePorCliente: number
    quantidadeMaxima: number | null
    valorMinimoPedido: number | null
    maximoDesconto: number | null
    apenasPrimeiraCompra: boolean
    automatico: boolean
    ativo: boolean
    freteGratis: boolean
    appSiteTodos: number
    validadeDias: number | null
    fimCupomTimestamp: number | null
    visivelTelaInicial: boolean
    horarioAlmoco: boolean
    exigirFacebookParaDesconto: boolean
    exigirEnderecoUnicoParaDesconto: boolean
    exigirCpfParaDesconto: boolean
    telefoneCliente: string | null
    descricao: string
    olharListaClientes: boolean
    quantidadeUtilizada: number
}

export type CupomEstabelecimentoFornecedorModel = {
    cupons: CupomItem[]
    pendingDelete: number[]
    _nextLocalId: number
}

export const CupomEstabelecimentoFornecedorInicial: CupomEstabelecimentoFornecedorModel = {
    cupons: [],
    pendingDelete: [],
    _nextLocalId: 1,
}
